"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
/**
 * Use as a controlled component (supply `checked` and `onChange` props) or
 * with a `RadioGroup` component.
 *
 * For a label, use the `<FormField>` component.
 */


var Radio = function Radio(_ref) {
  var className = _ref.className,
      radioRef = _ref.radioRef,
      other = _objectWithoutProperties(_ref, ["className", "radioRef"]);

  return _react2.default.createElement("div", {
    className: (0, _classnames2.default)("mdc-radio", className)
  }, _react2.default.createElement("input", _extends({
    className: "mdc-radio__native-control",
    type: "radio",
    ref: radioRef
  }, other)), _react2.default.createElement("div", {
    className: "mdc-radio__background"
  }, _react2.default.createElement("div", {
    className: "mdc-radio__outer-circle"
  }), _react2.default.createElement("div", {
    className: "mdc-radio__inner-circle"
  })));
};

Radio.propTypes = {
  /** Classname to be used on Radio. */
  className: _propTypes2.default.string,

  /** Callback ref to access the reference of the input field of radio type. */
  radioRef: _propTypes2.default.func
};
Radio.defaultProps = {
  className: "",
  radioRef: function radioRef() {}
};
exports.default = Radio;